import { createFileRoute } from "@tanstack/react-router";
import { ServicePartnersPage } from "@/servicePartners/ServicePartnersPage";
import { parseServicePartnersSearch } from "@/servicePartners/servicePartnersSearch";

export const Route = createFileRoute(
  "/_authenticated/platform-management_/service-partners",
)({
  validateSearch: parseServicePartnersSearch,
  component: ServicePartnersRoute,
});

function ServicePartnersRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <ServicePartnersPage
      {...search}
      onQueryChange={(q) => {
        void navigate({
          replace: true,
          search: (previous) => ({
            ...previous,
            page: 1,
            q: q.trim() || undefined,
          }),
        });
      }}
      onChainChange={(chain) => {
        void navigate({
          search: (previous) => ({ ...previous, page: 1, chain }),
        });
      }}
      onPageChange={(page, replace = false) => {
        void navigate({
          replace,
          search: (previous) => ({ ...previous, page: Math.max(1, page) }),
        });
      }}
    />
  );
}
